var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import CategoryLabelLink from "backpack-ui/dist/components/categoryLabelLink";
import { Heading } from "backpack-ui/dist/components/text";
import * as cn from "classnames";
import * as React from "react";
import imageSizes from "../../utils/imageSizes";
import removeHTML from "../../utils/removeHTML";
import ListItemImage from "../listItemImage";
import * as styles from "./styles.css";
var createMarkup = function (markup) {
    return { __html: markup };
};
var ListItem = function (_a) {
    var category = _a.category, categoryLink = _a.categoryLink, description = _a.description, link = _a.link, thumbnail = _a.thumbnail, title = _a.title, type = _a.type, className = _a.className;
    return (React.createElement("article", { className: cn(styles.ListItem, className) },
        React.createElement("div", { className: styles.textContainer },
            category &&
                React.createElement("div", { className: styles.category },
                    React.createElement(CategoryLabelLink, { href: categoryLink, tabIndex: -1 }, category)),
            React.createElement("a", { className: styles.textAnchor, href: link },
                React.createElement(Heading, { className: styles.heading, level: 3, size: 7, weight: "medium", style: {
                        color: "currentColor",
                    } }, removeHTML(title)),
                React.createElement("p", { className: styles.description, dangerouslySetInnerHTML: createMarkup(description) }))),
        thumbnail &&
            React.createElement("div", { className: styles.thumbnail },
                React.createElement("a", { className: styles.thumbnailAnchor, href: link, tabIndex: -1 },
                    React.createElement(ListItemImage, __assign({ className: cn(type === "thorntree" && styles.imageRounded), src: thumbnail }, imageSizes[type]))))));
};
export default ListItem;



//////////////////
// WEBPACK FOOTER
// ./app/modules/search/components/listItem/index.tsx
// module id = Rx5D
// module chunks = 2